module.exports = __webpack_public_path__ + "img/photo_2023-11-22 13.51.27.f035ee91.jpg";